import { useState } from "react";
import SideBar from "../../Common/SideBar";
import { useSelector } from "react-redux";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";
import { Outlet } from "react-router-dom";

const LoyaltyScreen = () => {
  const sidebar = useSelector(state => state.sidebar);

  return (
    <div className="h-screen flex overflow-hidden">
      {/* <SideBar /> */}
      <div
        className={`${
          sidebar.expand
            ? "dashboardInnerSidebarBig"
            : "dashboardInnerSidebarSmall"
        } flex flex-col overflow-hidden`}>
        <BreadCrumbsContainer />
        <div className="flex-1 overflow-auto bg-[#F9F9F9]">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LoyaltyScreen;
